export default __webpack_public_path__ + "static/media/ringtone.1c11a14b.mp3";